var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSwapArrows(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3519 5.77734V16.1481C15.3519 16.5774 15.7004 16.9259 16.1297 16.9259C16.5591 16.9259 16.9075 16.5774 16.9075 16.1481V5.77734C16.9075 5.34799 16.5591 4.99954 16.1297 4.99954C15.7004 4.99954 15.3519 5.34799 15.3519 5.77734Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.64802 18.2222V7.85144C9.64802 7.42209 9.29956 7.07363 8.87021 7.07363C8.44086 7.07363 8.09241 7.42209 8.09241 7.85144V18.2222C8.09241 18.6515 8.44086 19 8.87021 19C9.29956 19 9.64802 18.6515 9.64802 18.2222Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0867 8.91956L16.1298 6.87756L18.1728 8.91956C18.4756 9.22343 18.9693 9.22343 19.2721 8.91956C19.576 8.61674 19.576 8.12309 19.2721 7.82026L16.6794 5.22758C16.3755 4.92371 15.884 4.92371 15.5801 5.22758L12.9874 7.82026C12.6836 8.12309 12.6836 8.61674 12.9874 8.91956C13.2902 9.22343 13.7839 9.22343 14.0867 8.91956Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9133 15.0797L8.87024 17.1217L6.8272 15.0797C6.52437 14.7759 6.03072 14.7759 5.7279 15.0797C5.42403 15.3826 5.42403 15.8762 5.7279 16.179L8.32059 18.7717C8.62445 19.0756 9.11602 19.0756 9.41989 18.7717L12.0126 16.179C12.3164 15.8762 12.3164 15.3826 12.0126 15.0797C11.7097 14.7759 11.2161 14.7759 10.9133 15.0797Z",
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwapArrows);
export default __webpack_public_path__ + "static/media/swapArrows.b396856b353600cc6114d49b46ff6860.svg";
export { ForwardRef as ReactComponent };